exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.signature-preview[data-v-bf5296ba] {\n    margin-top: 10px;\n    border: 1px solid #ccc;\n    padding: 10px;\n    font-size: 24px;\n    height: 100px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: #000000;\n}\n.pointer-cursor[data-v-bf5296ba] {\n    cursor: pointer;\n}\n", ""]);

// exports
